import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { TextField, InputLabel, Select, MenuItem, FormControl, Input, FormHelperText } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import _ from "lodash";
import { Utils } from "common/Utils";

const viewDataOnly = false
const ViewEmployeeBenefitsHistory = forwardRef(({ fetchedData, employee ,errors}, ref) => {
  
  return (
    <>
    <table className="table tableall--wrapper ">
      <thead>
        <tr>
          <th role="columnheader">Benefit</th>
          <th role="columnheader">Benefit Type</th>
          <th role="columnheader">Start Date</th>
          <th role="columnheader">End Date</th>
          <th role="columnheader">Coverage</th>
          <th role="columnheader">Carrier</th>
          <th role="columnheader">Coverage Amount</th>
          <th role="columnheader">EE Cost</th>
          <th role="columnheader">ER Cost</th>
        </tr>
      </thead>
      <tbody>
        {fetchedData.data.map((val, i) => (<tr>
          <td>{val.benefit}</td>
          <td>{val.benefitType}</td>
          <td>{Utils.formatDate(val.startDate)}</td>
          <td>{Utils.formatDate(val.endDate)}</td>
          <td>{val.coverage}</td>
          <td>{val.carrier}</td>
          <td>{val.coverageAmount}</td>
          <td>{(val.eeMonthlyCost==0?"":val.eeMonthlyCost)}</td>
          <td>{(val.erMonthlyCost==0?"":val.erMonthlyCost)}</td>
        </tr>))}
      </tbody>
    </table>


    </>
  )
});

export default ViewEmployeeBenefitsHistory;